import React, { useState } from 'react';
import './Cotizacion.scss'
// import Gracias from './Gracias';
import UseModalGracias from "./UseModalGracias";
import Gracias from "../../pages/Gracias/Gracias";

import { useHistory } from "react-router-dom";
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';

import emailjs from '@emailjs/browser';
import ReactDOM from 'react-dom';
import { Formik } from 'formik';

import logo1 from "../../assets/navbar/logo.svg";

const Cotizacion = ({ isShowingCoti, hideCoti }) => {
  const [showMessage, setShowMessage] = useState(false);
  const [showModalGracias, setShowModalGracias]= useState(!isShowingCoti);
  const { isShowingGracias, toggleGracias } = UseModalGracias()
  const [nombreCotizacion, setNombreCotizacion] = useState('');

  const history = useHistory();

  console.log("isShowingGracias:", isShowingGracias)
  
  const styleOfModalGracias = {
    position: 'absolute',
    top: (isMobile() ? '52%' : '55%'),
    left: isMobile() ? '0' : '55%',
    paddingTop: '24px !important',
    // transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const styleButtonOfModalGracias={
    width: '168px',
    height: '32px',
    background: '#D67E1B',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.14)',
    borderRadius: '7px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '13px',
    lineHeight: '32px',
    color: 'black !important'
  };

  function isMobile() {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ){
      console.log("es Mobile")
      return true;
    }
      
    else {
      console.log("es web")
      return false;
    }
      
  }

  return (
    isShowingCoti ? ReactDOM.createPortal(
      <React.Fragment>
        <div className="modal-overlay2" />
        <div className="modal-wrapper2" aria-modal aria-hidden tabIndex={-1} role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="btn-close btn-close-white" onClick={hideCoti} ></button>
                <p>Deje sus datos y aproveche</p>
                <h3>Nuestros descuentos online</h3>
              </div>
              <div class="modal-body">

                {showMessage ? <div className="alert alert-success col-md-5 mx-auto" role="alert">La solicitud de cotización se ha enviado correctamente</div> : ``}
                <Formik
                  initialValues={{ interes: '', nombre: '', Apellido: '', ApellidoMaterno: '', telefono: '', email: '' }}
                  validate={values => {
                    let errors = {};
                    if (!values.email) {
                      errors.email = 'El email es requerido';
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    ) {
                      errors.email = 'Debe ingresar un formato de email valido';
                    }

                    if (!values.nombre){
                      errors.nombre = 'Debe ingresar un nombre';
                    } else if (
                      !/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(values.nombre)
                    ) {
                      errors.nombre = 'El nombre solo puede contener letras y espacios'
                    }
                    if (!values.Apellido){
                      errors.Apellido = 'Debe ingresar un apellido';
                    } else if (
                      !/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(values.Apellido)
                    ) {
                      errors.Apellido = 'El apellido solo puede contener letras y espacios'
                    }
                    if (!values.ApellidoMaterno){
                      errors.ApellidoMaterno = 'Debe ingresar un apellido materno';
                    } else if (
                      !/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(values.ApellidoMaterno)
                    ) {
                      errors.ApellidoMaterno = 'El apellido materno solo puede contener letras y espacios'
                    }

                    if (!values.telefono){
                      errors.telefono = 'Debe ingresar un telefono';
                    }
                    else if (
                      !/^[0-9]{1,8}$/g.test(values.telefono)
                    ) {
                      errors.telefono = 'El numero de telefono debe tener hasta 8 digitos'
                    }

                    if (!values.interes){
                      errors.interes = 'Debe seleccionar una opcion';
                    }


                    return errors;
                  }}
                  onSubmit={(values) => {
                    console.log(values.email)
                    setNombreCotizacion(values.nombre)

                  // emailjs.send('default_service', 'template_29btuij', values, 'user_4lFOCE5PsoRvvRs43ggs8')

                    emailjs.send('service_yh7w7l8', 'template_0c59dwb', values, '5ZfPCnE6jv4NCuedY')
                    .then((response) => {
                      console.log('SUCCESS!', response.status, response.text);

                     if (window.gtag) {window.gtag('event', 'generate_lead');}

                  
                      history.push("/gracias");

                      // var whatsappAsistente=document.getElementById("whatsapp-asistente")
                      // console.log("whatsappAsistente1:", whatsappAsistente)
                      // whatsappAsistente.style.display="none";

                      // toggleGracias()
                      // console.log("whatsappAsistente2:", whatsappAsistente)
                      // whatsappAsistente.style.display="block";
                      // // hideCoti();
                    }, (err) => {
                      console.log('FAILED...', err);
                      hideCoti()
                    });

                  }}
                >
                  {({
                    handleBlur,
                    isSubmitting,
                    errors,
                    handleSubmit,
                    values,
                    handleChange,
                    touched
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div class="row">
                        <div class="col">
                          <div class="form-floating">
                            <input
                              type="text"
                              class="form-control"
                              id="floatingInput"
                              placeholder="Nombre"
                              onChange={handleChange}
                              name="nombre"
                              value={values.nombre}
                              onBlur={handleBlur}
                            />
                             {touched.nombre && errors.nombre && <div id="error">{errors.nombre} </div>}
                            <label for="floatingInput"></label>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-floating">
                            <input
                              type="text"
                              class="form-control"
                              id="floatingInput"
                              placeholder="Apellido paterno"
                              onChange={handleChange}
                              name="Apellido"
                              value={values.Apellido}
                              onBlur={handleBlur}
                            />
                            {touched.Apellido && errors.Apellido && <div id="error">{errors.Apellido}</div>}
                            <label for="floatingInput"></label>
                          </div>
                        </div>
                      </div>
                      <div class="row">&nbsp;</div>
                      <div class="row">
                        <div class="col">
                          <div class="form-floating">
                            <input
                              type="text"
                              class="form-control"
                              id="floatingInput"
                              placeholder="Apellido materno"
                              onChange={handleChange}
                              name="ApellidoMaterno"
                              value={values.ApellidoMaterno}
                              onBlur={handleBlur}
                            />
                             {touched.ApellidoMaterno && errors.ApellidoMaterno && <div id="error">{errors.ApellidoMaterno}</div>}
                            <label for="floatingInput"></label>
                          </div>
                        </div>
                        <div class="col ">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control"
                              id="floatingInput"
                              placeholder="Teléfono"
                              onChange={handleChange}
                              name="telefono"
                              value={values.telefono}
                              onBlur={handleBlur}
                            />
                            {touched.telefono && errors.telefono && <div id="error">{errors.telefono}</div>}
                            <label for="floatingInput"></label>
                          </div>
                        </div>
                      </div>
                      <div class="row">&nbsp;</div>
                      <div class="row">
                        <div class="col">
                          <div class="form-floating">
                            <input
                              type="text"
                              className="form-control"
                              id="floatingInput"
                              placeholder="Su dirección de e-mail"
                              onChange={handleChange}
                              name="email"
                              value={values.email}
                              onBlur={handleBlur}
                            />
                            {touched.email && errors.email && <div id="error">{errors.email} </div>}
                            <label for="floatingInput"></label>
                          </div>
                        </div>
                      </div>
                      <div class="row">&nbsp;</div>
                      <div class="row">
                        <div class="col">
                          <select className="form-control custom-select custom-select-lg mb-3 comboInt"
                            style={{ padding: '1rem' }}
                            value={values.interes}
                            onChange={handleChange}
                            name="interes"
                            onBlur={handleBlur}
                          >
                            <option value='' >Selecccione la cantidad de capacidades que desea</option>
                            <option value="Sepultura 2 niveles" >Sepultura 2 niveles</option>
                            <option value="Sepultura 3 niveles">Sepultura 3 niveles</option>
                            <option value="Sepultura 4 niveles">Sepultura 4 niveles</option>
                            <option value="No lo tengo decidido">No lo tengo decidido</option>
                          </select>
                            {touched.interes && errors.interes && <div id="error">{errors.interes} </div>}
                        </div>
                      </div>
                      <div className="pt-3 col-md-5 mx-auto text-left m-4 divBtnCotizar">
                        <button className="btn btn-info btnCotizar" type="submit" disabled={isSubmitting} >COTIZAR</button>
                      </div>
                    </form>
                  )
                  }
                </Formik>
              </div>
            </div>
          </div>
        </div>

        {/* <React.Fragment>
          <Modal
            open={isShowingGracias}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box sx={{ ...styleOfModalGracias, width: (isMobile() ? '100%' : '45%'), height: (isMobile() ? '48%' : '45%') }}>
              <img src={logo1} alt="" class="logo" id="navbar-logo"/>
              <br></br>
              <br></br>
              <h4 id="child-modal-title">Estimado/a {nombreCotizacion}</h4>
              <p style={{fontSize: '0.9rem'}}>
                Agradecemos su consulta y la información proporcionada.<br></br>
                Su cotización se está procesando, un ejecutivo lo contactará a la brevedad para asesorarlo/a y responder todas sus dudas.
              </p>

              <div style={{width: '70%'}}>
                <p style={{fontSize: '0.8rem', position: 'absolute', bottom: '7px'}}>
                  Puedes contactarte con nuestro Asistente Virtual vía Whatsapp
                </p>
              </div>

              <button href="/" style={{width: '200px', height: '36px', fontSize: '0.9rem', background: '#D67E1B', borderRadius: '7px', color: '#000000'}} onClick={()=>{toggleGracias(); hideCoti();}}>
                Continuar visitando el sitio
              </button>              
            </Box>
          </Modal>
        </React.Fragment> */}

      </React.Fragment>, document.getElementById('modal')
    ) : null
  )
}
export default Cotizacion;
